const MessageFormat = {
  Raw: 0,
  Markdown: 1,
  Maths: 2,
};

export default MessageFormat;
